import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { FootnotesFeature } from '../../+state';

@Component({
    selector: 'lib-footnotes',
    templateUrl: './footnotes.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: true,
})
export class FootnotesComponent {
    store = inject(Store);
    footnotes = this.store.selectSignal(FootnotesFeature.state.selectNumberedFootnotes);
}
